import React from 'react';

import { PageHeader } from '../ui/PageHeader';
import { Card } from '../ui/Card';

const impactSections = [
  {
    kicker: 'Community Development',
    title: 'Community Development',
    bullets: ['Local employment supported', 'Training for guides and operators', 'Community projects funded'],
    image: '/images/community/maasai-community-dance.jpg',
    imageAlt: 'Community-led project activity',
  },
  {
    kicker: 'Conservation Impact',
    title: 'Conservation Impact',
    bullets: ['Wildlife protection initiatives', 'Habitat restoration', 'Anti‑poaching support'],
    image: '/images/wildlife/elephant-family.jpg',
    imageAlt: 'Wildlife conservation',
  },
  {
    kicker: 'Ethical Travel Metrics',
    title: 'Ethical Travel Metrics',
    bullets: ['Verified operators onboarded', 'Agencies supported', 'Safaris conducted under ethical guidelines'],
    image: '/images/wildlife/giraffe.jpg',
    imageAlt: 'Ethical safari travel',
  },
  {
    kicker: 'Financial Transparency',
    title: 'Financial Transparency',
    bullets: ['Clear reporting on how funds are allocated to community and conservation efforts'],
    image: '/images/impact/community-beekeeping.jpg',
    imageAlt: 'Transparent impact reporting',
  },
];

export default function ImpactReviewPage() {
  return (
    <div className="page heroPage">
      <div className="container">
        <PageHeader
          kicker="Impact Review"
          title="Impact That Matters"
          subtitle="Transparent reporting on community development, conservation, and ethical travel outcomes."
        />

        <p className="muted" style={{ marginTop: 0, lineHeight: 1.7, maxWidth: 900 }}>
          As a nonprofit, SafariCo Hub is committed to measurable, transparent impact. Our annual review highlights how agency partnerships,
          local operators, and community projects work together to create meaningful change.
        </p>

        <div className="grid" style={{ marginTop: 22, gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }}>
          {impactSections.map((sec) => (
            <Card key={sec.title} title={sec.title}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <img className="mediaImage" src={sec.image} alt={sec.imageAlt} />
                <div className="kicker">{sec.kicker}</div>
                <div className="missionList" style={{ marginTop: 0 }}>
                  {sec.bullets.map((b) => (
                    <div key={b} className="missionItem">
                      <span className="missionDot" aria-hidden="true" />
                      <span>{b}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}

